module.exports = __webpack_public_path__ + "img/huangguan.b870c186.png";